import { gql } from '@apollo/client';

export const GET_CONTENT_SHARES = gql`
  query getSharesByContent($contentId: String!) {
    getSharesByContent(contentId: $contentId) {
      message
      result {
        id
        ownerCompanyName
        targetCompanyName
        permission
        userId
        userName
      }
    }
  }
`;

export const GET_INCOMING_SHARES = gql`
  query getIncomingShares {
    getIncomingShares {
      message
      result {
        id
        contentTitle
        ownerCompanyName
        createdAt
        status
      }
    }
  }
`;

export const GET_USER_AND_COMPANY_TO_SHARE = gql`
  query getUserAndCompanyToShares($q: String!) {
    getUserAndCompanyToShares(q: $q) {
      message
      result {
        id
        name
        type
      }
    }
  }
`;
